module.exports = __webpack_public_path__ + "static/media/strongher16.e68f383b.jpg";